import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
const SECRET_KEY = 'adminSecret';

function AdminSecretGate({ children }) {
    const [authed, setAuthed] = useState(false);
    const [secretInput, setSecretInput] = useState('');
    const [error, setError] = useState('');
    const [checking, setChecking] = useState(true);

    useEffect(() => {
        const saved = sessionStorage.getItem(SECRET_KEY);
        if (!saved) {
            setChecking(false);
            return;
        }
        axios.get(`${API_URL}/admin/tos`, { headers: { 'X-Admin-Secret': saved } })
            .then(() => setAuthed(true))
            .catch(() => {
                sessionStorage.removeItem(SECRET_KEY);
            })
            .finally(() => setChecking(false));
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        try {
            await axios.get(`${API_URL}/admin/tos`, { headers: { 'X-Admin-Secret': secretInput } });
            sessionStorage.setItem(SECRET_KEY, secretInput);
            setAuthed(true);
        } catch (err) {
            if (err.response?.status === 401) {
                setError('Invalid secret.');
            } else {
                setError('Could not connect to API.');
            }
        }
    };

    if (checking) return null;
    if (authed) return children;

    return (
        <div style={styles.page}>
            <div style={styles.card}>
                <h2 style={styles.heading}>Admin Access Required</h2>
                <form onSubmit={handleSubmit}>
                    <input
                        type="password"
                        placeholder="Admin secret"
                        value={secretInput}
                        onChange={(e) => setSecretInput(e.target.value)}
                        style={styles.input}
                        autoFocus
                        required
                    />
                    {error && <p style={styles.error}>{error}</p>}
                    <button type="submit" style={styles.btn}>Continue</button>
                </form>
            </div>
        </div>
    );
}

const styles = {
    page: {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f5f5f5',
        fontFamily: 'sans-serif',
    },
    card: {
        background: '#fff',
        borderRadius: 8,
        padding: '32px 40px',
        boxShadow: '0 2px 12px rgba(0,0,0,0.10)',
        minWidth: 280,
    },
    heading: {
        margin: '0 0 20px',
        fontSize: 20,
        fontWeight: 600,
    },
    input: {
        display: 'block',
        width: '100%',
        padding: '8px 10px',
        fontSize: 14,
        border: '1px solid #ccc',
        borderRadius: 4,
        marginBottom: 12,
        boxSizing: 'border-box',
    },
    btn: {
        background: '#1a73e8',
        color: '#fff',
        border: 'none',
        borderRadius: 4,
        padding: '8px 20px',
        fontSize: 14,
        cursor: 'pointer',
        width: '100%',
    },
    error: {
        color: '#c00',
        fontSize: 13,
        margin: '0 0 10px',
    },
};

export default AdminSecretGate;
